/**
 * Layout class names for custom table clones (e.g. Taxonomy DnD).
 * Prefer `getDataTableCellProps` for cells; do not import this from product pages.
 */
import styles from './DataTable.module.css';

export const dataTableLayoutStyles = styles;

/** Match `wpDatatableRowHighlightPulse` in DataTable.module.css. */
export const DATA_TABLE_ROW_HIGHLIGHT_PULSE_MS = 2400;

/** Strip `?highlight*` query params after pulse (+ small buffer). */
export const DATA_TABLE_ROW_HIGHLIGHT_STRIP_MS = 2600;
